import { translate } from "@/utils/langUtils";
import "./style.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Block, CRRender, Inline } from "../../crRender";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

const RedioBtns = ({ List = [], className = '', name, formHandler, label=null, isRequired = true ,defaultValue}) => {

  const { i18n, t } = useTranslation()
  const { formValues, handleFormValues,touchedFields } = formHandler

  const MappedList = useMemo(() => List.map((item) => ({
    label: translate(item?.label),
    value: item?.value
  })), [List, i18n?.language])


  useEffect(() => {
    handleFormValues(name, { value: defaultValue ?? null, isRequired, isError: false }, { markAsTouched: false })
  }, [name, defaultValue, isRequired])
 
  const haveVal = (val)=>{
  return val != null || val != undefined
  }
  const isTouched =touchedFields[name] == true ? true :false;



  return (
    <div className={`selector form-group  ${className} ${formValues[name]?.isError ? "field-required" : ""}`}>
      <Block isRender={name && !label} className="d-flex ">
        <label htmlFor={name}>{translate("Select all that apply") + " " + translate(name)}</label>
        <Inline isRender={isRequired} className={"required"}>*</Inline>
      </Block>
      <Block isRender={label} className="d-flex">
        <label htmlFor={name}>{translate(label)}</label>
        <Inline isRender={isRequired} className={"required"}>*</Inline>
      </Block>
      <div className="row spec-selector px-4">
        {MappedList.map((specialty) =>
          <div key={specialty?.value} onClick={() => handleFormValues(name, { value: specialty?.value, isRequired, isError: false })}
            className={`option ${(formValues[name]?.value ?? defaultValue) === specialty?.value ? "option--active" : ""} col-lg-4 col-md-6 col-sm-12 `} >
            <div className={`option__check ${(formValues[name]?.value ?? defaultValue) === specialty?.value ? "selected" : ""}`}>
              <Icon className="check-true-icon" icon={"lets-icons:check-fill"} />
            </div>
            <div className="option__text">{specialty?.label}</div>
          </div>
        )}
      </div>
      <CRRender isRender={isRequired && !haveVal(formValues[name]?.value) && isTouched} >
            <p className="error-message">{t("required-radio")}</p>
      </CRRender>
    </div>
  );
};

export default RedioBtns;

